import { SharedConstants } from "../../../../../shared/constants/shared.constants";
export class ViewApplicationFamilyCmConstants {
    static STEP_TITLE = "Family";
    static FAMILY_FORM_CONTROL_NAME = "family";
    static FAMILY_LABEL = "Family";
    static VALIDATION_MESSAGES = {
        family: {
            required: `Family ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }
    };
}
